export const listExecutions = `
   query listExecutions($filter: ExecutionsFilterInput, $limit: Int, $nextToken:  String) {
       listExecutions(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              playbookId
              playbook {
                  id
                  name
                  displayName
              }
              name
              executionStatus
              sfnExecutionArn
              currentPhase
              totalPhases
              completedPhases
              startedAt
              completedAt
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getExecution = `
   query getExecution($id:ID!) {
       getExecution(id:$id) {
         id
         playbookId
         playbook {
             id
             name
             displayName
         }
         name
         description
         executionStatus
         sfnExecutionArn
         executionInput
         executionOutput
         currentPhase
         totalPhases
         completedPhases
         startedAt
         completedAt
         failedStepId
         failedStepName
         failureReason
         createdByUsername
         created
         updated
         phases {
             id
             executionId
             phaseId
             phaseName
             position
             phaseStatus
             startedAt
             completedAt
             created
             updated
             steps {
                 id
                 executionId
                 executionPhaseId
                 stepId
                 phaseId
                 stepName
                 taskStateName
                 position
                 stepStatus
                 startedAt
                 completedAt
                 elapsedMs
                 input
                 output
                 errorMessage
                 errorType
                 retryCount
                 created
                 updated
             }
         }
       }
}`;
